import React, { useContext, useState, useEffect, useRef } from 'react'

import {ReactComponent as Lang} from '../assets/icons/lang.svg'
import { useLanguage } from '../Context/LanguageContext'
import { useNavigate } from 'react-router-dom'

const Langselect = () => {
    const [isOpen, setOpen] = useState(false)
    const {setLanguage, language} = useLanguage()
    const navigate = useNavigate()
    const ref = useRef(null);

    const toggle = () => {
        setOpen(prev => !prev);
    }

    const select = (lang) => {
        if((language === "zh" && lang !== "zh") || (language !== "zh" && lang === "zh")){
              navigate("/")
              window.scrollTo({
                top: 0,
                left: 0,
              });
        }
    
        setLanguage(lang)
        setOpen(false)
        setOpen(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return ( 
        <div ref={ref} className={`lang-select ${isOpen && "open"}`}>
            <button className='icon-wrapper' onClick={toggle}>
                <Lang/>
            </button>

            <div className='options'>

                <span/>

                <img className='flag' title='Deutsch' alt='Auf Deutsch wechseln' onClick={() => select("de")} src="./images/germany.webp" width="32" height="24" />
                <img className='flag' title='English' alt='Switch to English' onClick={() => select("en")} src="./images/english.webp" width="32" height="24" />

                <span/>

                <img className='flag' title='中文' alt='切换到中文' onClick={() => select("zh")} src="./images/china.webp" width="32" height="24" />
            </div>
        </div> 
    );
}
 
export default Langselect;